export default __webpack_public_path__ + "media/Objective/Objective-Regular-0ccc8c2f94336db02bded184706ca32d.woff2";